import theme from "../../../style/theme";
// import { OutlineRoutePinProps } from "../../../types/Pin/outline-route-pin";
import { OutlineRoutePin } from "./OutlineRoutePin";
import { OutlineRoutePinProps } from "./outline-route-pin-props";

export const GrayOutlineRoutePin: React.FC<OutlineRoutePinProps> = ({
  number,
  rightLabel,
  leftLabel,
}) => {
  return (
    <OutlineRoutePin
      backgroundColor={theme.palette.primitives["gray600"]}
      borderColor={theme.palette.primitives["gray50"]}
      color={theme.palette.primitives["gray50"]}
      borderWidth={1}
      number={number}
      rightLabel={rightLabel}
      leftLabel={leftLabel}
    />
  );
};
